// The Join settings words shared by the Joining card's one-line summary and the dialog (R43 L1, X108: the card and
// the dialog must say the same about the Join button). A club's link on the new-link default (2, club players)
// works as link only there (JoinSettingsControls pageValue): club players are already in.

/** The page-setting words the Join settings dialog uses, for a club (referenceType 0) or any other entity. */
export function joinPageSettingLabel(referenceType, inviteEntityPageSetting) {
    const v = referenceType === 0 && inviteEntityPageSetting === 2 ? 1 : inviteEntityPageSetting;
    if (v === 1) return 'hidden, link only';
    if (v === 2) return 'shown to club players';
    return 'shown to everyone';
}

/**
 * "Anyone · they join straight away · Join button hidden, link only": who, how, and the Join button, each in the
 * Join settings dialog's own words (X110, R46 L3: "They join straight away" / "You approve each request").
 */
export function joinSummaryLine(s) {
    const l = s?.link ?? {};
    const who = s?.referenceType === 0 ? 'Anyone' : (l.inviteScope === 1 ? 'Club players' : 'Anyone');
    const how = l.inviteJoinSetting === 1 ? 'you approve each request' : 'they join straight away';
    return `${who} · ${how} · Join button ${joinPageSettingLabel(s?.referenceType, l.inviteEntityPageSetting)}`;
}
